var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 29 21","width":"29","height":"21"}},[_c('path',{attrs:{"d":"M26.683 2.354L10.947 18.091a2 2 0 0 1-2.829 0l-6.381-6.382"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }